// In frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <>
    <App />
    <ToastContainer />
  </>,
  document.getElementById('root')
);


// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import './styles/App.css';

// ReactDOM.render(
//     <React.StrictMode>
//         <App />
//     </React.StrictMode>,
//     document.getElementById('root')
// );
